import history from "./history";

export default function redirect(location) {
  history.push(location);
}